import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Show from '../views/Show.vue'
import SubmitUpdate from '../components/SubmitUpdate.vue'
import SubmitSave from '../components/SubmitSave.vue'
import UserShow from '@/views/UserShow.vue'
import UserSubmitSave from '../components/UserSubmitSave.vue'
import UserSubmitUpdate from '../components/UserSubmitUpdate.vue'

Vue.use(VueRouter)


const routes = [
  {
    path: '/',
    name:'Login',
    component: Login
  },{
    path: '/show',
    name:'Show',
    component: Show
  },{
    path: '/submitUpdate',
    name:'SubmitUpdate',
    component: SubmitUpdate
  },{
    path: '/SubmitSave',
    name:'SubmitSave',
    component: SubmitSave
  },{
    path: '/userShow',
    name:'UserShow',
    component: UserShow
  }
  ,{
    path: '/userSubmitUpdate',
    name:'UserSubmitUpdate',
    component: UserSubmitUpdate
  }
  ,{
    path: '/userSubmitSave',
    name:'UserSubmitSave',
    component: UserSubmitSave
  }
]

const router = new VueRouter({
  routes
})

export default router
